import { Box, Card, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import Palette from '../../theme/palette'
import Addemail from '../../components/email/Addemail'

const Moreinformation = ({ data, isLoading }) => {

    const [open, setOpen] = useState(false)

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    // open instagram
    const handleInsta = (link) => {
        const url = `https://www.instagram.com/${link}`
        window.open(url)
    }

    // open Twitter
    const handleTwitter = (link) => {
        const url = `https://twitter.com/${link}`
        window.open(url)
    }

    // dfgdfg
    return (
        <div>
            {/* Add Email Model */}
            <Addemail open={open} handleClose={handleClose} _id={data?._id} receiver={data} />

            {isLoading ? (
                <Card style={{ display: 'flex', justifyContent: 'center', paddingBottom: "70px" }}>
                    <span className="loader" />
                </Card>
            ) : (
                <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
                    <Box p={3}>
                        <Grid container display="flex" spacing={4}>
                            <Grid item xs={12} sm={6} >
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                                    <Typography variant="h4" pb={2} >Client Details :-</Typography>
                                    <Typography variant="body1">Client's name :</Typography>
                                    {
                                        data?.contact_id ?
                                            <Link to={`/dashboard/contact/view/${data?.contact_id?._id}`} style={{ textDecoration: "none" }}>
                                                <Typography variant="body2" color={Palette.primary.main} textTransform={"capitalize"}>{`${data?.contact_id?.firstName} ${data?.contact_id?.lastName}`}</Typography>
                                            </Link>
                                            :
                                            <Typography variant="body2" color={Palette.grey[600]} textTransform={"capitalize"}>{data?.clientName}</Typography>
                                    }
                                </Grid>
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                                    <Typography variant="body1">Client's date of birth :</Typography>
                                    <Typography variant="body2" color={Palette.grey[600]}>
                                        {
                                            data?.clientDateOfBirth ? dayjs(data?.clientDateOfBirth).format('MM/DD/YYYY') : "--"
                                        }
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} pb={2}>
                                    <Typography variant="h4" pb={2} >Client's contact information :-</Typography>
                                    <Typography variant="body1"> Phone Number :</Typography>
                                    <Typography variant="body2" color={Palette.grey[600]}>{data?.phoneNumber ? data?.phoneNumber : "--"}</Typography>
                                </Grid>
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                                    <Typography variant="body1">Email :</Typography>
                                    <Typography variant="body2" color={Palette.primary.main} onClick={handleOpen} style={{ cursor: "pointer" }}>{data?.emailAddress ? data?.emailAddress : "--"}</Typography>
                                </Grid>
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                                    <Typography variant="h4" py={2} >Project Project Costs and Payments :-</Typography>
                                    <Typography variant="body1">Project Cost amount :</Typography>
                                    <Typography variant="body2" color={Palette.grey[600]}>{data?.projectCost ? data?.projectCost : "--"}</Typography>
                                </Grid>
                                <Grid style={{ borderBottom: "1.5px dashed", borderBottomColor: Palette.grey[400] }} py={2}>
                                    <Typography variant="body1">Frequency of Project Cost payments :</Typography>
                                    <Typography variant="body2" color={Palette.grey[600]}>{data?.Frequency ? data?.Frequency : "--"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
            )}


        </div>
    )
}

export default Moreinformation
